import client from 'lib/apiClient';

export const TYPES = {
  INTERCOM_ATTR: 'send_intercom_attribute',
  SEND_MAIL: 'send_email',
  SEND_TEMPLATE_MAIL: 'send_email_template',
  VALIDATE_10DLC: 'validate_10dlc',
  EXPORT_REPORT: 'export_report',
  SEND_HUBSPOT_PROP: 'send_hubspot_property',
};

export const queueMsg = (type, data) =>
  client.post('API/1_0/postRabbitMQ.php', {
    type,
    ...data,
  });

export const getSyncQueue = () =>
  client
    .get('API/1_0/getRabbitMQ.php?queue=RABBITMQ_SYNC_QUEUE_NAME')
    .then((resp) => resp.Attributes.ApproximateNumberOfMessages);

export const getQueueSize = (name) =>
  client.get(`API/1_0/getRabbitMQ.php`, {
    params: { queue: 'RABBITMQ_MESSAGE_QUEUE_NAME' },
  });

export const TEMPLATES = {
  INVITE_USER: {
    qa: {
      tic: 'iTEL1P9ugDp7OuNKUfQS',
      tmg: 'kOq0LkRS95TGo77Avt61',
    },
    prod: {
      tic: 'iTEL1P9ugDp7OuNKUfQS',
      tmg: '8MzJU5pBRgTRzEjmObNY',
    },
  },
  THANK_MAIL: '4sEVtQpPkKBP37FrWI5n',
  SCRIPT_INSTRUCTIONS: {
    qa: {
      tic: 'rMWqRyjPDWJrJLBkJWOc',
      tmg: 'ojLGWHiLuX4ooTPXfpj2',
    },
    prod: {
      tic: 'WMsdmtmXFDBfTvhgeYgW',
      tmg: 'nU8vr6RzkGqy2B5dxxwU',
    },
  },
};
